/**
 * Global config for custom dropdowns (contribution steps, etc.).
 * Use for position check (open upward when space below is limited).
 */

/** Approximate height in px per option row for space calculation */
export const DROPDOWN_OPTION_HEIGHT_ESTIMATE = 50;

/** Max panel height in px (should match --dropdown-panel-max-height where possible) */
export const DROPDOWN_PANEL_MAX_HEIGHT = 300;

/** Extra padding (px) to add to estimated panel height */
export const DROPDOWN_PANEL_PADDING_ESTIMATE = 20;

/**
 * Returns whether the dropdown panel should open upward based on viewport space.
 * Use in checkDropdownPosition / before opening a dropdown.
 */
export function getDropdownShouldOpenUpward(
  triggerRect: DOMRect,
  optionCount: number,
  options?: {
    optionHeight?: number;
    maxHeight?: number;
    padding?: number;
  }
): boolean {
  const optionHeight = options?.optionHeight ?? DROPDOWN_OPTION_HEIGHT_ESTIMATE;
  const maxHeight = options?.maxHeight ?? DROPDOWN_PANEL_MAX_HEIGHT;
  const padding = options?.padding ?? DROPDOWN_PANEL_PADDING_ESTIMATE;
  const estimatedHeight = Math.min(maxHeight, optionCount * optionHeight + padding);
  const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 0;
  const spaceBelow = viewportHeight - triggerRect.bottom;
  const spaceAbove = triggerRect.top;
  return spaceBelow < estimatedHeight && spaceAbove > estimatedHeight;
}
